import React from 'react';
import { reduxForm, Field } from 'redux-form';

import FormError from '../../FormError';
import InputField from 'components/InputField';
import CheckboxField from 'components/CheckboxField';
import SelectSearchField from 'components/SelectSearchField';

let CreateSimoDeviceForm = ({ simoAccounts, handleSubmit, error }) => {
  const simoAccountsOptions =
    simoAccounts && simoAccounts.length
      ? simoAccounts.map((acc) => ({ name: acc.name, value: acc.id }))
      : [];

  return (
    <form className="mar-t" onSubmit={handleSubmit}>
      <Field
        component={InputField}
        name="serial_number"
        label="Serial Number*"
      />
      <Field component={InputField} name="name" label="Name*" />
      <Field
        component={SelectSearchField}
        name="account_id"
        label="Account Name*"
        options={simoAccountsOptions}
        placeholder="Select account name"
        hideEmptyWhenHasValue={true}
        formName="createSimoDevice"
      />
      <Field
        component={CheckboxField}
        name="sync"
        label="Device already active"
      />
      {error && <FormError error={error} />}
      <br />
      <button className="btn btn-default">Create Device</button>
    </form>
  );
};

const validate = (values) => {
  let errors = {};

  if (!values.serial_number) {
    errors.serial_number = 'Required';
  }
  if (!values.name) {
    errors.name = 'Required';
  }
  if (!values.account_id) {
    errors.account_id = 'Required';
  }

  return errors;
};

CreateSimoDeviceForm = reduxForm({
  form: 'createSimoDevice',
  enableReinitialize: true,
  validate,
})(CreateSimoDeviceForm);

export default CreateSimoDeviceForm;
